import { render, staticRenderFns } from "./CompanyReportsPage.vue?vue&type=template&id=b7b593b4&scoped=true"
import script from "./CompanyReportsPage.vue?vue&type=script&lang=js"
export * from "./CompanyReportsPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyReportsPage.vue?vue&type=style&index=0&id=b7b593b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b593b4",
  null
  
)

export default component.exports